var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group date date-picker" }, [
    _vm.displayNextPrevious
      ? _c("span", { staticClass: "input-group-btn" }, [
          _c(
            "button",
            {
              staticClass: "btn blue",
              class: _vm.buttonClasses,
              attrs: { type: "button", tabindex: "-1", disabled: _vm.disabled },
              on: { click: _vm.previousDay }
            },
            [_c("i", { staticClass: "fa fa-arrow-left" })]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("input", {
      ref: "date-picker",
      staticClass:
        "no-focus form-control form-control-inline input_placeholder",
      class: _vm.inputClasses,
      attrs: {
        name: _vm.name,
        type: "text",
        placeholder: _vm.placeholder,
        disabled: _vm.disabled
      },
      domProps: { value: _vm.value },
      on: { change: _vm.onChange }
    }),
    _vm._v(" "),
    _vm.displayNextPrevious
      ? _c("span", { staticClass: "input-group-btn" }, [
          _c(
            "button",
            {
              staticClass: "btn blue",
              class: _vm.buttonClasses,
              attrs: { type: "button", tabindex: "-1", disabled: _vm.disabled },
              on: { click: _vm.nextDay }
            },
            [_c("i", { staticClass: "fa fa-arrow-right" })]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }